import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import {
  elevatedSurfaceBoxShadow,
  transition,
} from '../../shared/style-settings'

export const useDonateStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 0),
      },
    },
    secondaryHeaderClassName: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(3),
      paddingLeft: '0px',
      paddingRight: '24px',
      maxWidth: '1280px',
      margin: '0 auto',
    },
    goBackButton: {
      borderRadius: theme.shape.borderRadius * 2,
      textTransform: 'none',
      transition: transition,
      marginLeft: '16px',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.primary.main,
      },
      '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(0.5),
      },
    },
    //pageTitle: {
    //  fontWeight: 700,
    //  color: theme.palette.text.primary,
    //  fontSize: 'clamp(1.5rem, 4vw, 2rem)',
    //  paddingLeft: '22px',
    //},
    publishSuccessBanner: {
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0),
      backgroundColor: theme.palette.success.main,
      color: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius * 2,
      fontWeight: 500,
      textAlign: 'center',
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    inputHolder: {
      marginBottom: theme.spacing(4),
      background: theme.palette.background.paper,
      padding: theme.spacing(4),
      borderRadius: theme.shape.borderRadius * 3,
      boxShadow: elevatedSurfaceBoxShadow,
      border: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius * 2,
      },
      // Form field improvements
      '& .MuiOutlinedInput-root': {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
      },
      '& .MuiInputLabel-outlined': {
        color: theme.palette.grey[700],
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: theme.palette.primary.main,
      },
      '& .MuiInputLabel-outlined.Mui-error': {
        color: theme.palette.error.main,
      },
      '& .MuiFormLabel-root': {
        color: theme.palette.grey[700],
        fontWeight: 600,
        fontSize: '0.8125rem',
        textAlign: 'start',
        '&.Mui-focused': {
          color: theme.palette.primary.main,
        },
      },
      '& .MuiFormLabel-root.Mui-error': {
        color: theme.palette.error.main,
      },
      '& .MuiFormHelperText-root': {
        color: theme.palette.grey[600],
        fontWeight: 600,
      },
      '& .MuiFormHelperText-root.Mui-error': {
        color: theme.palette.error.main,
      },
      '& .MuiFormControlLabel-label': {
        color: theme.palette.grey[700],
        fontWeight: 600,
        fontSize: '0.8125rem',
      },
    },
    shippingAddressAlert: {
      paddingTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      '& .MuiAlert-root': {
        borderRadius: theme.shape.borderRadius * 2,
      },
      '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    addAddressButton: {
      lineHeight: 1,
      minheight: 0,
      padding: 1,
      verticalAlign: 'baseline',
      textDecoration: 'none',
      color: theme.palette.primary.main,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    btnHolder: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      flexWrap: 'wrap',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse',
        alignItems: 'stretch',
        '& button': {
          width: '100%',
          marginLeft: '0 !important',
          marginRight: '0 !important',
        },
      },
    },
    loadedBtnHolder: {
      display: 'flex',
      justifyContent: 'center',
      gap: theme.spacing(2),
      marginTop: theme.spacing(3),
      '& button': {
        borderRadius: theme.shape.borderRadius * 2,
        fontWeight: 600,
        textTransform: 'none',
        padding: theme.spacing(1.5, 4),
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        '& button': {
          width: '100%',
        },
      },
    },
    btnBack: {
      marginLeft: 'auto',
      [theme.breakpoints.down('xs')]: {
        marginLeft: 0,
      },
    },
    btnDraft: {
      marginRight: 'auto',
      borderRadius: theme.shape.borderRadius * 2,
      fontWeight: 500,
      textTransform: 'none',
      padding: theme.spacing(1.5, 3),
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
    stepperOffset: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
      background: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 3,
      padding: theme.spacing(3, 2),
      boxShadow: elevatedSurfaceBoxShadow,
      '& .MuiStepLabel-label': {
        fontWeight: 500,
        fontSize: '0.875rem',
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.75rem',
        },
      },
      '& .MuiStepLabel-label.MuiStepLabel-active': {
        fontWeight: 600,
        color: theme.palette.primary.main,
      },
      '& .MuiStepLabel-label.MuiStepLabel-completed': {
        fontWeight: 500,
        color: theme.palette.success.main,
      },
      '& .MuiStepIcon-root': {
        fontSize: '1.5rem',
        transition: transition,
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.25rem',
        },
      },
      '& .MuiStepIcon-text': {
        fontSize: '0.7rem',
        fontWeight: 800,
        [theme.breakpoints.down('sm')]: {
          fontSize: '0.625rem',
        },
      },
      '& .MuiStepIcon-active': {
        color: theme.palette.primary.main,
        transform: 'scale(1.04)',
      },
      '& .MuiStepIcon-completed': {
        color: theme.palette.success.main,
      },
      '& .MuiStepConnector-line': {
        borderColor: theme.palette.divider,
      },
      '& .MuiStepConnector-active .MuiStepConnector-line': {
        borderColor: theme.palette.primary.main,
      },
      '& .MuiStepConnector-completed .MuiStepConnector-line': {
        borderColor: theme.palette.success.main,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    },
    alert: {
      padding: theme.spacing(0, 0, 2, 0),
      '& .MuiAlert-root': {
        borderRadius: theme.shape.borderRadius * 2,
      },
    },
    loading: {
      position: 'absolute',
      padding: theme.spacing(2, 0),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      top: '40%',
      left: '50%',
      zIndex: 1,
    },
    additionalBlock: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
      '& .MuiFormLabel-root': {
        textAlign: 'left',
      },
    },
  })
)
